import * as React from 'react'
import clx from 'classnames'

type Props = {
  checked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

export const Toggle = ({
  checked = false,
  onChange,
  disabled = false,
  className,
}: Props) => {
  return (
    <label
      className={clx(
        'tw-relative tw-mb-0 tw-inline-flex tw-items-center',
        disabled ? 'tw-cursor-default' : 'tw-cursor-pointer',
        className,
      )}
    >
      <input
        type="checkbox"
        className={clx('tw-sr-only')}
        style={{ top: 0, left: 0 }}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span
        className={clx(
          'tw-relative tw-inline-block tw-h-6 tw-w-10 tw-rounded-full tw-border tw-transition-colors tw-duration-200',
          disabled && 'tw-border-base-300 tw-bg-base-300',
          {
            'tw-border-focus-100 tw-bg-focus-100': checked && !disabled,
            'tw-border-gray-300 tw-bg-[#CCD5F6]': !checked && !disabled,
          },
        )}
      >
        <span
          className={clx(
            'tw-absolute tw-top-1/2 tw-h-5 tw-w-5 -tw-translate-y-1/2 tw-rounded-full tw-shadow-sm tw-transition-transform tw-duration-100',
            checked ? 'tw-translate-x-4' : 'tw-translate-x-0.5',
            disabled ? 'tw-bg-base-200' : 'tw-bg-white',
          )}
        />
      </span>
    </label>
  )
}
